import React, { useState, useEffect } from "react";
import styled, { ThemeProvider } from "styled-components";
import { theme } from "../public/theme";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { SG_GET_SLACK_SCHEDULER, SG_DELETE_SLACK_SCHEDULER } from "constants/actions";
import { Link } from "react-router-dom";

const SlackSchedulerList = () => {
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch({ type: SG_GET_SLACK_SCHEDULER, payload: { page: currentPage } });
  }, [dispatch, currentPage]);

  const { get_slack_scheduler } = useSelector(
    (state) => ({
      get_slack_scheduler: state.slack_scheduler,
    }),
    shallowEqual
  );

  const { results: currentSchedulers, count, page_size: schedulersPerPage } = get_slack_scheduler.slack_schedulers;

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  function handleDelete(id) {
    // Handle the delete action
    dispatch({ type: SG_DELETE_SLACK_SCHEDULER, payload: id });
  }

  return (
    <ThemeProvider theme={theme}>
      <ListContainer>
        <h1>  Slack Scheduler List</h1>
        {currentSchedulers && currentSchedulers?.length > 0 ? (
          <List>
            {currentSchedulers.map((scheduler) => (
              <ListItem key={scheduler.id}>
                <strong>Name:</strong> {scheduler.name} <br />
                <strong>Bot:</strong> {scheduler?.slack_bot_name} <br />
                <strong>Status:</strong> {scheduler.status} <br />
                <strong>Schedule Type:</strong> {scheduler.schedule_type} <br />
                <strong>Alert Time:</strong> {scheduler.alert_time} <br />
                <strong>Timezone:</strong> {scheduler.timezone} <br />
                <strong>Schedule Specs:</strong> {JSON.stringify(scheduler.schedule_specs)} <br />
                <strong>Last Triggered:</strong> {scheduler.last_triggered} <br />
                <strong>Next Triggered:</strong> {scheduler?.next_run_datetime} <br />
                <LinkButton to={`/leader/audit/slack-scheduler/details/${scheduler.id}`}>Details</LinkButton>
                <LinkButton to={`/leader/audit/slack-scheduler/edit/${scheduler.id}`}>Edit</LinkButton>

                <StyledButton onClick={() => handleDelete(scheduler.id)}>Delete [Maybe Need to do some checks e.g never run before]</StyledButton>
              </ListItem>
            ))}
          </List>
        ) : (
          <p>Loading...</p>
        )}
        <Pagination>
          {Array.from({ length: Math.ceil(count / schedulersPerPage) }, (_, index) => (
            <PageNumber key={index + 1} onClick={() => paginate(index + 1)}>
              {index + 1}
            </PageNumber>
          ))}
        </Pagination>
      </ListContainer>
    </ThemeProvider>
  );
};

export default SlackSchedulerList;

const ListContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
`;

const List = styled.div`
  margin-top: 20px;
`;

const ListItem = styled.div`
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const PageNumber = styled.span`
  margin: 0 5px;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #f0f0f0;
  }
`;

const LinkButton = styled(Link)`
  display: inline-block;
  margin-top: 10px;
  margin-right: 10px;
  padding: 5px 10px;
  background-color: #007bff;
  color: white;
  text-decoration: none;
  border-radius: 5px;

  &:hover {
    background-color: #0056b3;
  }
`;

const StyledButton = styled.button`

`